// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * @internal
 */
export const packageVersion = "1.12.1";

/**
 * @internal
 */
export const appConfigurationApiVersion = "2026-04-01";
